<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Atribuição de parâmetro por grupo"
    >
        <rkm-form>
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        @change="handleReguladoChange"
                        label="Regulado"
                        show-default-option
                        v-model="model.isRegulado"
                    >
                        <rkm-form-select-option :value="true">Sim</rkm-form-select-option>
                        <rkm-form-select-option :value="false">Não</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>

                <rkm-col>
                    <rkm-form-select label="Tipo"
                        :disabled="!model.isRegulado"
                        :options="form.tipos"
                        show-default-option
                        text-field="nome"
                        v-model="model.regulacaoTipoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        label="PPI"
                        show-default-option
                        v-model="model.isPpi"
                    >
                        <rkm-form-select-option :value="true">Sim</rkm-form-select-option>
                        <rkm-form-select-option :value="false">Não</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="8">

                    <rkm-form-select
                        label="Exigir peso, altura e circunferência abdominal para solicitação de exame de imagem"
                        show-default-option
                        v-model="model.exigirPesoAlturaCircunferencia"
                    >
                        <rkm-form-select-option :value="true">Sim</rkm-form-select-option>
                        <rkm-form-select-option :value="false">Não</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="items"
            @filter-changed="handleFilterChanged"
            @filtered="itemsFiltered = $event"
        >
            <template v-slot:head(checkboxes)>
                <rkm-form-checkbox
                    :indeterminate="indeterminate"
                    :value="true"
                    @change="checkUncheckAll"
                    v-model="checkedAll"
                />
            </template>

            <template v-slot:cell(checkboxes)="{item}">
                <rkm-form-checkbox
                    :value="true"
                    @change="handleCheckedAll"
                    v-model="item.selecionado"
                />
            </template>
        </rkm-table>

        <template v-slot:footer="{cancel}">
            <rkm-button
                @click="cancel"
                color="secondary"
            >
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="items.filter(item => item.selecionado).length === 0"
                @click="store"
                color="primary"
            >
                Atribuir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        fields() {
            return [
                {class: 'col-min text-center', key: 'checkboxes', label: '#'},
                {key: 'nome', label: 'Grupo', sortable: true},
            ]
        },
    },
    created() {
        this.repositories = {
            exame: this.getConectaSusRepository('parametrizacao.exame')
        }
    },
    data: () => ({
        checkedAll: false,
        form: {
            tipos: null,
        },
        indeterminate: false,
        items: [],
        itemsFiltered: [],
        model: {
            isPpi: null,
            isRegulado: null,
            regulacaoTipoId: null,
            exigirPesoAlturaCircunferencia: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {
            this.$refs.RkmModal.show()
            this.load()
        },
        load() {
            this.setLoading()

            this.repositories.exame.index({listar: 'grupos'})
                .then((response) => {
                    if (response.data.grupos) {
                        this.items = response.data.grupos.map(data => ({...data, selecionado: false}))
                    }

                    this.form.tipos = response.data.tipos
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        store() {
            this.setLoading()

            const request = {
                action: 'atribuicao-parametro-grupo',
                grupos: this.items.filter(item => item.selecionado).map(item => item.id),
            }

            if (this.model.regulacaoTipoId) {
                request.regulacaoTipoId = this.model.regulacaoTipoId
            }

            if (this.model.isPpi !== null) {
                request.isPpi = this.model.isPpi
            }

            if (this.model.exigirPesoAlturaCircunferencia !== null) {
                request.exigirPesoAlturaCircunferencia = this.model.exigirPesoAlturaCircunferencia
            }

            this.repositories.exame.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(() => {
                    this.showSaveNotification()
                    this.exit()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.model.isPpi = null
            this.model.isRegulado = null
            this.model.regulacaoTipoId = null
            this.model.exigirPesoAlturaCircunferencia = null
        },
        exit() {
            this.$refs.RkmModal.hide()
        },
        handleReguladoChange() {
            this.model.regulacaoTipoId = null
            this.model.isPpi = null
        },
        handleFilterChanged() {
            this.checkedAll = false
            this.indeterminate = false
            this.items.map(item => item.selecionado = false)
        },
        handleCheckedAll() {
            this.checkedAll = false
            this.indeterminate = false

            const itemsCount = this.itemsFiltered.length

            const selectedItemsCount = this.items
                .filter(item => this.itemsFiltered.find(itemFiltered => itemFiltered.id === item.id))
                .filter(item => item.selecionado === true).length

            if (selectedItemsCount > 0) {
                if (selectedItemsCount === itemsCount) {
                    this.checkedAll = true
                } else  {
                    this.indeterminate = true
                }
            }
        },
        checkUncheckAll(value) {
            this.checkedAll = value
            this.indeterminate = false

            this.items
                .filter(item => this.itemsFiltered.find(itemFiltered => itemFiltered.id === item.id))
                .map(item => item.selecionado = value)
        },
    },
    mixins: [error, repository, stringCase],
    watch: {
        'items'(value) {
            this.checkedAll = false
            this.indeterminate = false
            this.itemsFiltered = value
        }
    }
}
</script>